/**
 * Import
 */
import { message } from 'antd';
import { Box, Button, Input, Text } from 'components';
import { maxNumberOfTerminalsSelector } from 'features/merchants/redux';
import { FirebaseCollectionsType } from 'firebaseAPI';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useFirestore } from 'react-redux-firebase';

type TerminalSettingsModalProps = {
  accountId: string;
};
/**
 * TerminalSettingsModal
 */
const TerminalSettingsModal: React.FC<TerminalSettingsModalProps> = (props) => {
  const firestore = useFirestore();
  const maxNumberOfTerminals = useSelector(
    maxNumberOfTerminalsSelector(props.accountId),
  );
  const [maxValue, setMaxValue] = useState(maxNumberOfTerminals ?? 0);
  function isValidIntegerInput(value: number) {
    // Check if it's a number, an integer, and within range
    return Number.isInteger(value) && value >= 1 && value <= 999;
  }
  const onHandleUpdateMaxTerminals = async () => {
    try {
      if (isValidIntegerInput(maxValue)) {
        await firestore
          .collection(FirebaseCollectionsType.VIBRANT_API_ACCOUNTS)
          .doc(props.accountId)
          .update({
            'settings.maxNumberOfTerminals': maxValue,
          });
        message.success('Max terminals updated');
      } else {
        message.error('Failed to update max terminals');
      }
    } catch {
      throw new Error('Failed to update max terminals');
    }
  };

  return (
    <Box>
      <Box mb="16px">
        <Text size="h5">Update max terminals</Text>
      </Box>
      <Input
        type="number"
        value={maxValue}
        defaultValue={maxNumberOfTerminals ?? undefined}
        onChange={(event) => setMaxValue(Number(event.currentTarget.value))}
      />
      <Box mt="24px">
        <Button onClick={onHandleUpdateMaxTerminals}>Save</Button>
      </Box>
    </Box>
  );
};
/**
 * Export
 */
export { TerminalSettingsModal };
